'use client'

import React, { useState, useCallback, useEffect, useMemo } from 'react'
import { useRouter, usePathname } from 'next/navigation'
import { useLocale, useTranslations } from 'next-intl'

import { TOOLBAR_LINKS, TOOLBAR_PATH_MAP } from '@/src/constants/bottomToolbar'
import { getActiveToolbarTab } from '@/src/utils/navigation/getActiveToolbarTab'

import { BottomToolbar } from './bottomToolbar'

const BottomToolbarWrapper: React.FC = () => {
    const router = useRouter()
    const pathname = usePathname()
    const t = useTranslations('common')
    const locale = useLocale()

    // Initialize with active tab based on current URL
    const [currentValue, setCurrentValue] = useState<string>(() => getActiveToolbarTab(pathname))

    // Update active tab when pathname changes
    useEffect(() => {
        const activeTab = getActiveToolbarTab(pathname)
        setCurrentValue(activeTab)
    }, [pathname])

    const handleNavigationChange = useCallback( 
        (value: string) => {
            let path = `/${locale}${TOOLBAR_PATH_MAP[value]}`
            if (path) {
                if (path.includes('hotels')) {
                    window.location.href = `https://www.flyin.com/${locale}/hotels`;
                } else {
                    router.push(path)
                }
            }
        },
        [router]
    )

    // Translate toolbar links
    const translatedToolbarLinks = useMemo(
        () =>
            TOOLBAR_LINKS.map(link => ({
                ...link,
                label: t(link.label),
            })),
        [t, locale]
    )

    return (
        <BottomToolbar
            currentValue={currentValue}
            toolbarLinks={translatedToolbarLinks}
            onNavigationChange={handleNavigationChange}
        />
    )
}

export { BottomToolbarWrapper }
export default BottomToolbarWrapper
